document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-quantity-minus], [data-quantity-plus]');
  if (!btn) return;
  var wrap = btn.closest('[data-quantity-wrapper]');
  if (!wrap) return;
  var input = wrap.querySelector('.m-card-quantity__input');
  var min = parseInt(input.min, 10) || 1;
  var val = parseInt(input.value, 10) || min;
  val = btn.hasAttribute('data-quantity-minus') ? Math.max(min, val - 1) : val + 1;
  input.value = val;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});